export default __webpack_public_path__ + "assets/images/particles-77aa6388ecdbff5cbdd1a47895353423.jpg";